import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Install() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative flex min-h-screen flex-col">
      <Header />
      <main className="flex-grow">
        {/* HeroSection */}
        <section className="mx-auto max-w-[1200px] px-6 pt-6 pb-8 text-center">
          <div className="inline-flex items-center gap-2 bg-primary/10 dark:bg-primary/20 text-primary px-4 py-1.5 rounded-full text-sm font-bold mb-8">
            <span className="material-symbols-outlined text-[18px]">verified</span>
            موثوق به من قبل أكثر من 10,000 محترف
          </div>
          <div className="max-w-[800px] mx-auto">
            <h1 className="text-4xl md:text-6xl font-black leading-[1.1] tracking-tight mb-6 text-[#111318] dark:text-white">
              تثبيت Formly AI لـ Chrome
            </h1>
            <p className="text-lg md:text-xl text-[#616f89] dark:text-gray-400 mb-10 leading-relaxed">
              وفر ساعات من إدخال البيانات اليدوي. املأ أي نموذج بنقرة واحدة باستخدام الذكاء الاصطناعي الذي يفهم السياق.
            </p>
            <div className="flex flex-col items-center gap-6">
              <button className="flex min-w-[280px] items-center justify-center gap-3 rounded-xl h-14 px-8 bg-primary hover:bg-blue-700 text-white text-lg font-bold transition-all transform hover:scale-[1.02] shadow-xl shadow-primary/20">
                <span className="material-symbols-outlined">add_to_drive</span>
                إضافة إلى Chrome - مجاني
              </button>
              <div className="flex items-center gap-4 py-4">
                <div className="flex items-center gap-1 text-yellow-500">
                  <span className="material-symbols-outlined fill-1">star</span>
                  <span className="material-symbols-outlined fill-1">star</span>
                  <span className="material-symbols-outlined fill-1">star</span>
                  <span className="material-symbols-outlined fill-1">star</span>
                  <span className="material-symbols-outlined fill-1">star</span>
                </div>
                <span className="text-sm font-medium text-[#616f89] dark:text-gray-400">4.9/5 متجر Chrome الإلكتروني</span>
              </div>
            </div>
            {/* MetaText */}
            <p className="text-[#616f89] dark:text-gray-500 text-sm font-normal mt-4">
              تم التحقق من قبل Google Safe Browsing. لا حاجة لبطاقة ائتمانية.
            </p>
          </div>
        </section>
        {/* 1-2-3 Guide Section */}
        <section className="bg-white dark:bg-[#161d2b] pt-8 pb-12 border-y border-[#dbdfe6] dark:border-[#2a303c]">
          <div className="mx-auto max-w-[1200px] px-6">
            <div className="text-center mb-6">
              <h2 className="text-3xl font-bold tracking-tight text-[#111318] dark:text-white">كيف تبدأ</h2>
              <p className="text-[#616f89] dark:text-gray-400 mt-2">جاهز للعمل في أقل من 30 ثانية</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Step 1 */}
              <div className="group flex flex-col gap-6 rounded-2xl border border-primary/15 dark:border-primary/30 bg-gradient-to-r from-white to-primary/5 dark:from-gray-900 dark:to-primary/10 p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary mx-auto group-hover:bg-primary group-hover:text-white transition-all">
                  <span className="material-symbols-outlined">download</span>
                </div>
                <div className="flex flex-col gap-2 text-center">
                  <h3 className="text-xl font-bold text-[#111318] dark:text-white">1. اضغط إضافة</h3>
                  <p className="text-[#616f89] dark:text-gray-400 leading-relaxed">
                    اضغط على زر "إضافة إلى Chrome" أعلاه لزيارة متجر Chrome الإلكتروني وتثبيت الإضافة.
                  </p>
                </div>
              </div>
              {/* Step 2 */}
              <div className="group flex flex-col gap-6 rounded-2xl border border-primary/15 dark:border-primary/30 bg-gradient-to-r from-white to-primary/5 dark:from-gray-900 dark:to-primary/10 p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary mx-auto group-hover:bg-primary group-hover:text-white transition-all">
                  <span className="material-symbols-outlined">keep</span>
                </div>
                <div className="flex flex-col gap-2 text-center">
                  <h3 className="text-xl font-bold text-[#111318] dark:text-white">2. تثبيت الإضافة</h3>
                  <p className="text-[#616f89] dark:text-gray-400 leading-relaxed">
                    اضغط على أيقونة اللغز في شريط الأدوات وثبت Formly AI لإبقائها مرئية للوصول السهل.
                  </p>
                </div>
              </div>
              {/* Step 3 */}
              <div className="group flex flex-col gap-6 rounded-2xl border border-primary/15 dark:border-primary/30 bg-gradient-to-r from-white to-primary/5 dark:from-gray-900 dark:to-primary/10 p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary mx-auto group-hover:bg-primary group-hover:text-white transition-all">
                  <span className="material-symbols-outlined">magic_button</span>
                </div>
                <div className="flex flex-col gap-2 text-center">
                  <h3 className="text-xl font-bold text-[#111318] dark:text-white">3. ابدأ الملء</h3>
                  <p className="text-[#616f89] dark:text-gray-400 leading-relaxed">
                    انتقل إلى أي نموذج، اضغط على أيقونة Formly، وشاهد كيف تُملأ بياناتك بذكاء.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Install;

